import { render } from "./DeleteModalComponent.vue?vue&type=template&id=16c791ea"
import script from "./DeleteModalComponent.vue?vue&type=script&lang=js"
export * from "./DeleteModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__